'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var styled = require('styled-components');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
var loader$1 = require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
require('../../../../styles/styled-components/alert.js');
require('../../../../styles/styled-components/animations.js');
require('../../../../styles/styled-components/box-shadow.js');
require('../../../../styles/styled-components/button.js');
require('../../../../themes/alert.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
var fonts = require('../../../../themes/fonts.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
var themes = require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
require('../../../../styles/styled-components/font-face.js');
require('../../../../styles/styled-components/global.js');
require('../../../../styles/styled-components/input.js');
require('../../../../styles/styled-components/list.js');
require('../../../../styles/styled-components/listitem.js');
var loader = require('../../../../styles/styled-components/loader.js');
require('../../../../styles/styled-components/media-queries.js');
require('../../../../styles/styled-components/reset.js');
require('../../../../styles/styled-components/outline.js');
require('../../../../styles/styled-components/popout.js');
require('../../../../styles/styled-components/screen-reader.js');
require('../../../../styles/styled-components/switch.js');
require('../../../../styles/styled-components/tooltip.js');
var baseLoader = require('../base-loader/base-loader.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const BaseCircleLoader = (props)=>{
    const { buttonLook , className , label , labelPosition =loader$1.LoaderLabelPositions.Right , labelProps , look , showLabel =false , size =loader$1.LoaderSizes.Medium , svgCircleProps , svgProps , ...otherProps } = props;
    return /*#__PURE__*/ React__default.default.createElement(baseLoader.BaseLoader, _extends({}, otherProps, {
        "aria-label": showLabel ? undefined : label,
        "aria-hidden": buttonLook && !label ? true : undefined,
        className: classnames__default.default({
            'bf-loader__circle': true,
            [`bf-loader__circle--label-${labelPosition}`]: labelPosition,
            [`bf-loader__circle--look-${look}`]: look,
            [`bf-loader__circle--size-${size}`]: size,
            [`${className}`]: !!className
        })
    }), /*#__PURE__*/ React__default.default.createElement("svg", _extends({}, svgProps, {
        "aria-hidden": true,
        className: classnames__default.default({
            'bf-loader__svg': true,
            [`${svgProps?.className}`]: !!svgProps?.className
        }),
        viewBox: "25 25 50 50",
        role: "img"
    }), /*#__PURE__*/ React__default.default.createElement("circle", _extends({}, svgCircleProps, {
        className: classnames__default.default({
            'bf-loader__svg-circle': true,
            [`${svgCircleProps?.className}`]: !!svgCircleProps?.className
        }),
        cx: "50",
        cy: "50",
        r: "20"
    }))), showLabel && /*#__PURE__*/ React__default.default.createElement("span", _extends({}, labelProps, {
        className: classnames__default.default({
            'bf-loader__label': true,
            [`${labelProps?.className}`]: !!labelProps?.className
        })
    }), label));
};
const Loader = styled__default.default(BaseCircleLoader)`
  ${({ labelPosition , size  })=>loader.getLoaderPosition({
        labelPosition,
        size
    })}
  ${({ size  })=>loader.getLoaderSize({
        size
    })}
  ${({ buttonLook , look  })=>loader.getLoaderTheme({
        buttonLook,
        look
    })}
  align-items: center;
  box-sizing: border-box;
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
  overflow: hidden;
  width: 100%;

  .bf-loader__label {
    font-family: ${fonts.fontFamilyBook};
    max-width: 300px;
  }

  .bf-loader__svg {
    animation: ${loader.getLoaderRotate()} 2s linear infinite;
    flex-shrink: 0;
    transform-origin: center;
  }

  .bf-loader__svg-circle {
    fill: transparent;
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
    stroke-linecap: round;
    stroke-width: 5px;
    animation:
      ${({ look , theme  })=>loader.getLoaderStroke({
        look,
        theme
    })} 3s cubic-bezier(1, 0, 0, 1) infinite,
      ${loader.getLoaderStretch()} 1.5s ease-in-out infinite;
  }
`;
const CircleLoader = (props)=>{
    const { look =loader$1.LoaderLooks.Primary , ...otherProps } = props;
    const themeContext = React.useContext(styled.ThemeContext);
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, /*#__PURE__*/ React__default.default.createElement(Loader, _extends({
        look: look
    }, otherProps)));
};

exports.CircleLoader = CircleLoader;
//# sourceMappingURL=circle-loader.js.map
